import { createApi } from '@/api'
export default {
    equipmentTypeList: config => createApi(`/equipmentType/getList`, 'get', config), // 农产品类型列表
    addEquipmentType: config => createApi(`/equipmentType/add`, 'post', config), // 农产品类型添加
    deleteEquipmentType: config => createApi(`/equipmentType/delete`, 'delete', config), // 农产品类型删除
    updateEquipmentType: config => createApi(`/equipmentType/update`, 'post', config), // 农产品类型修改
    equipmentTypeDetail: config => createApi(`/equipmentType/get`, 'get', config) // 农产品类型详情
}



// WEBPACK FOOTER //
// ./src/views/equipmentTypeManage/api/index.js